module.exports = __webpack_public_path__ + "static/media/evacuation-bg3.0a000238.png";